import settingsFields from '@/components/services/settings/fields'

export default function(h, options) {
  return h(
    settingsFields(options),
    {
      props: {
        value: this.proxy,
        items: [
          {
            props: {
              suffix: this.getTranslate('misc.measure.time.sec'),
              type: 'number',
              step: 'any'
            }
          }
        ]
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
